const countries = require('i18n-iso-countries');
const countryLocaleDE = require('i18n-iso-countries/langs/de.json');
const countryLocaleEN = require('i18n-iso-countries/langs/en.json');
const countryLocaleCS = require('i18n-iso-countries/langs/cs.json');
const countryLocaleDA = require('i18n-iso-countries/langs/da.json');
const countryLocaleES = require('i18n-iso-countries/langs/es.json');
const countryLocaleFR = require('i18n-iso-countries/langs/fr.json');
const countryLocaleIT = require('i18n-iso-countries/langs/it.json');
const countryLocaleNL = require('i18n-iso-countries/langs/nl.json');
const countryLocalePL = require('i18n-iso-countries/langs/pl.json');
const countryLocalePT = require('i18n-iso-countries/langs/pt.json');
const countryLocaleRO = require('i18n-iso-countries/langs/ro.json');
const countryLocaleRU = require('i18n-iso-countries/langs/ru.json');
const countryLocaleSK = require('i18n-iso-countries/langs/sk.json');
const countryLocaleTR = require('i18n-iso-countries/langs/tr.json');
const countryLocaleZH = require('i18n-iso-countries/langs/zh.json');

countries.registerLocale(countryLocaleDE);
countries.registerLocale(countryLocaleEN);
countries.registerLocale(countryLocaleCS);
countries.registerLocale(countryLocaleDA);
countries.registerLocale(countryLocaleES);
countries.registerLocale(countryLocaleFR);
countries.registerLocale(countryLocaleIT);
countries.registerLocale(countryLocaleNL);
countries.registerLocale(countryLocalePL);
countries.registerLocale(countryLocalePT);
countries.registerLocale(countryLocaleRO);
countries.registerLocale(countryLocaleRU);
countries.registerLocale(countryLocaleSK);
countries.registerLocale(countryLocaleTR);
countries.registerLocale(countryLocaleZH);

/**
 *
 * Lib documentation: https://www.npmjs.com/package/i18n-iso-countries
 * @param country - Country code in ISO-3166
 * @param language - ISO 639-1 language code
 * @return {string}
 */
function translateCountry(country, language) {
    // we need the Alpha-2 Country code. We get a country string as "de_DE" where DE is the alpha-2 representation we need.
    return country && language ? countries.getName(country.value, language, {
        select: 'official',
    }) : '';
}

module.exports = translateCountry;
